import React from 'react'
import { Helmet } from 'react-helmet'
import { graphql, useStaticQuery } from 'gatsby'
import { useLocation } from '@reach/router'

export interface SeoTypes {
  title: string
  description?: string
  isCaninical?: boolean
  isNoindex?: boolean
  ogImage?: string
}
interface SeoProps {
  seo?: SeoTypes
}

const query = graphql`
  query Metadata {
    site {
      siteMetadata {
        defaultTitle
        defaultDescription
        siteUrl
      }
    }
  }
`

const SEO = ({ seo }: SeoProps) => {
  const { site } = useStaticQuery(query)
  const { pathname } = useLocation()
  const { defaultTitle, defaultDescription, siteUrl } = site.siteMetadata

  const formatSeo = {
    title: seo && seo.title ? `${seo.title} | ${defaultTitle}` : defaultTitle,
    description: (seo && (seo.description || `${seo.title}のページです。${defaultDescription}`)) || defaultDescription,
    canonical: `${siteUrl}${pathname}`,
    ogType: pathname === '/' ? 'website' : 'article',
    isCaninical: (seo && seo.isCaninical) || true,
    isNoindex: (seo && seo.isNoindex) || false,
    ogImage: (seo && seo.ogImage) || 'https://ashiatohr.com/ogp.png',
  }

  return (
    <Helmet>
      <html lang="ja" />
      <title>{formatSeo.title}</title>
      <meta name="description" content={formatSeo.description} />
      {formatSeo.isCaninical && formatSeo.canonical && <link rel="canonical" href={formatSeo.canonical} />}
      {/* OG */}
      <meta property="og:locale" content="ja_JP" />
      <meta property="og:type" content={formatSeo.ogType} />
      <meta property="og:title" content={formatSeo.title} />
      <meta property="og:description" content={formatSeo.description} />
      {formatSeo.isCaninical && formatSeo.canonical && <meta property="og:url" content={formatSeo.canonical} />}
      <meta property="og:image" content={formatSeo.ogImage} />
      <meta property="og:site_name" content={defaultTitle} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  )
}

export default SEO
